/**
 * Map an activity document from the API to a client route.
 * Project, Account, Client, User, and Card targets are supported; anything else with a
 * project resolves to that project.
 */

function toId(value) {
    if (value == null) return null;
    if (typeof value === 'object' && value._id != null) {
        return String(value._id);
    }
    return String(value);
}

/**
 * @param {object} activity — API activity document
 * @param {{ fallbackAccountSlug?: string }} [options] — URL slug for the current account when `activity.account` is not populated
 */
export function resolveActivityLink(activity, options = {}) {
    if (!activity) return null;

    const accountSlug = activity.account?.slug || options.fallbackAccountSlug || null;
    const clientSlug = activity.client?.slug;
    const projectId = toId(activity.project);

    const objectType = (activity.objectType || '').trim();
    const objectId = toId(activity.objectId);

    if (objectType === 'User' && objectId) {
        return `/user/${objectId}`;
    }

    if (objectType === 'Project' && objectId && accountSlug) {
        return `/account/${accountSlug}/project/${objectId}`;
    }

    if (objectType === 'Account' && objectId && accountSlug) {
        const accountRefId = toId(activity.account);
        if (!accountRefId || accountRefId === objectId) {
            return `/account/${accountSlug}`;
        }
    }

    if (objectType === 'Client' && objectId && clientSlug) {
        return `/client/${clientSlug}`;
    }

    const cardTaskId = toId(activity.additionalInfo?.taskId);
    const cardId = toId(activity.additionalInfo?.cardId);
    if (cardTaskId && cardId && projectId && accountSlug) {
        return `/account/${accountSlug}/project/${projectId}/task/${cardTaskId}/board?card=${cardId}`;
    }

    if (projectId && accountSlug) {
        return `/account/${accountSlug}/project/${projectId}`;
    }

    return null;
}
